export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'todo_type/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'todo_type/update', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'todo_type/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'todo_type/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/TodoType.js